import React from 'react';

export function Form({ title, fields = [], submit, change = () => {}, buttonTitle = 'Enviar' }) {
  const onChange = (index, input) => {
    const values = [...fields];
    values[index].value = input;
    change(values);
  };
  const onSubmit = (event) => {
    event.preventDefault();
    submit(fields);
  };

  return (
    <form className="flex flex-col space-y-6" onSubmit={(event) => onSubmit(event)}>
      {title && (
        <div className="border-b border-slate-100 pb-4">
          <h3 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h3>
          <p className="text-xs text-slate-500 mt-1">Completa los campos para enviar tu mensaje.</p>
        </div>
      )}
      <div className="w-full">
        <div className="grid gap-4 sm:grid-cols-2">
          {fields.map(({ Component, type, label, placeholder, ...props }, index) => (
            <Component
              key={index}
              change={(input) => onChange(index, input)}
              type={type}
              label={label}
              placeholder={placeholder}
              {...props}
            />
          ))}
        </div>
      </div>
      <button
        type="submit"
        className="w-full py-3 px-5 rounded-xl bg-primary hover:bg-primary-hover active:scale-[0.98] text-white font-bold text-sm shadow-md shadow-primary/25 hover:shadow-lg hover:shadow-primary/35 transition-all duration-200 cursor-pointer"
      >
        {buttonTitle}
      </button>
    </form>
  );
}

